import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type CreateCommunityShareableLinkDto = {
  community_id: number;
  expires_in_days?: number;
};

export type ApiResponse_CreateCommunityShareableLink = {
  shareable_link: string;
  short_code: string;
  expires_at: string | null;
};

const METHOD = 'POST';
const ENDPOINT = 'communities/shareable-link';

export const useGenerateCommunityShareableLink = () => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: CreateCommunityShareableLinkDto) => {
      const response = await handleApiCall<
        ApiResponse_CreateCommunityShareableLink,
        CreateCommunityShareableLinkDto
      >(
        session,
        METHOD,
        ENDPOINT,
        data
      );
      return response;
    },
  });
};